(function () {
        const overlayWrapper = document.querySelector('.overlay-box-wrapper');
        if(overlayWrapper && window.innerWidth >= 1200 && window.innerWidth <= 1366 ) {
            overlayWrapper.style.margin = "-10rem 0rem 0rem 0rem"
        }
       
})()
